import { environment } from '../../../../../environments/environment';

const NotifPath = '/push-notification';
const approvalPath = '/approval/project-registration';

const refreshToken = '/user/refreshToken';

export const NotifPathConst = `${environment.api.baseUrl}${NotifPath}`;
export const ApprovalPathConst = `${environment.api.baseUrl}${approvalPath}`;

export const refreshTokenPathConst = `${environment.api.baseUrl}${refreshToken}`;




